export default __webpack_public_path__ + "static/privacy-dark-9ea74b43903dd0ba20c942caf78bf9aa.png";